import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { PublicOfferEntityNormalized } from '../../../../../../../../../store/product/types';
import { PublicOfferAssetProvider } from '../../../../../contexts/products/PublicOffer';
import { ItemDetails } from '../Details';

import { PublicOfferItemDesktop } from './desktop';
import { PublicOfferItemMobile } from './mobile';
import { PublicOfferItemTablet } from './tablet';

export namespace PublicOfferItemTypes {
  export interface Props {
    offer: PublicOfferEntityNormalized;
  }
}

export const PublicOfferItem: React.FC<PublicOfferItemTypes.Props> = ({ offer }) => {
  const publicOfferItem = useBreakpointValue({
    base: <PublicOfferItemMobile offer={offer} />,
    sm: <PublicOfferItemTablet offer={offer} />,
    lg: <PublicOfferItemDesktop offer={offer} />,
  });

  return (
    <PublicOfferAssetProvider>
      <ItemDetails />
      {publicOfferItem}
    </PublicOfferAssetProvider>
  );
};
